import React, { useState } from "react";
import styled from "styled-components";
import { Table } from "components";
import colors from "theme/colors";
import {
  ProductDetailPanelHeaderInline,
  ProductDetailPanelHeaderRow,
} from "pages/Products/pages/ProductDetail/ProductDetailPanelHeader";
import {
  addPVA,
  addRuleset,
  removeRuleset,
  removeTag,
  addTag,
} from "store/reducers/products/parameters/parameters.actions";
import { useDispatch } from "react-redux";
import { addPVAFields } from "./AddRows/PVARow";
import { removePVA } from "store/reducers/products/parameters/parameters.actions";
import { useTypedSelector } from "store";
import { getTableData } from "pages/Products/components/ParametersTable/helpers";
import { addRulesetFields } from "./AddRows/ruleSetsAddRow";
import { addTagFields } from "./AddRows/addTagsRow";
import { Add } from "../../../../assets/logos/icons/MicroIcons";

export function ParametersTable({
  parameterType,
  addRowButtonLabel,
  header,
  className,
}: {
  parameterType: "pva" | "ruleSets" | "tags";
  addRowButtonLabel?: string;
  header: string;
  className?: any;
}) {
  const [showAddRow, setShowAddRow] = useState<boolean>(false);
  const dispatch = useDispatch();

  const handlePressAdd = () => {
    setShowAddRow((showAddRow) => !showAddRow);
  };

  const mapParameterTypeToTables = {
    pva: {
      deleteFunction: (id) => dispatch(removePVA(id)),
      addRowContent: addPVAFields,
      pressAdd: () => dispatch(addPVA()),
    },
    ruleSets: {
      deleteFunction: (id) => dispatch(removeRuleset(id)),
      addRowContent: addRulesetFields,
      pressAdd: () => dispatch(addRuleset()),
    },
    tags: {
      deleteFunction: (id) => dispatch(removeTag(id)),
      addRowContent: addTagFields,
      pressAdd: () => dispatch(addTag()),
    },
  };

  const tableData = getTableData(
    useTypedSelector((state) => state.products.parameters),
    parameterType,
    mapParameterTypeToTables[parameterType].deleteFunction
  );
  return (
    <Wrapper className={className}>
      <ProductDetailPanelHeaderRow>
        <ProductDetailPanelHeaderInline bold color={colors.muttedHeadlines}>
          {header}
        </ProductDetailPanelHeaderInline>
        <StyledAddIcon onClick={handlePressAdd} />
      </ProductDetailPanelHeaderRow>
      <TableSection>
        <Table
          data={tableData}
          canAddRow={showAddRow}
          addRowAction={mapParameterTypeToTables[parameterType].pressAdd}
          addRowContent={mapParameterTypeToTables[parameterType].addRowContent}
          addRowButtonLabel={addRowButtonLabel}
          size={"small"}
        />
      </TableSection>
    </Wrapper>
  );
}

export default ParametersTable;

export const HeaderWrapper = ProductDetailPanelHeaderRow;

/** @deprecated Use ProductDetailPanelHeaderInline from ProductDetailPanelHeader */
export const StyledH4 = ProductDetailPanelHeaderInline;

const StyledAddIcon = styled(Add)<any>`
  cursor: pointer;
`;

const TableSection = styled.div`
  padding: 0 32px;
`;

const Wrapper = styled.div<any>``;
